import { render } from "./ModelsPopup.vue?vue&type=template&id=756b61d8&scoped=true"
import script from "./ModelsPopup.vue?vue&type=script&lang=js"
export * from "./ModelsPopup.vue?vue&type=script&lang=js"

import "./ModelsPopup.vue?vue&type=style&index=0&id=756b61d8&scoped=true&lang=css"

import exportComponent from "D:\\projects\\mitool\\MITOOL\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756b61d8"]])

export default __exports__